module.exports = __webpack_public_path__ + "img/Country4-1.f03bed23.png";